import * as actions from "../actions/actions";
import * as actionTypes from "../actions/actionTypes";

import { connect } from "react-redux";
import { hashHistory } from "react-router";
import ColorPicker from "./nounproject-color-picker";

import React from "react";

import IconList from "./nounproject-iconlist";
import NounProjectPreviewIcon from "./nounproject-preview-icon";
import Icon from "./nounproject-ui-icon";
import ColorSelection from "./color-selection";

class NounProjectPluginIconDetail extends React.Component {
    componentDidMount() {
        this.props.setActiveIcon(this.props.iconId);
        this.props.fetchIcon(this.props.iconId);
        this.props.fetchViewMoreIcons(this.props.iconId, 24, 0);
    }

    componentWillReceiveProps(nextProps) {
        if (
            (nextProps.apiResponse.actionType ===
                actionTypes.FETCH_PNG_DATA_SUCCESS &&
                this.state.insertLoading) ||
            (nextProps.apiResponse.actionType ===
                actionTypes.REPORT_PLUGIN_USAGE_SUCCESS &&
                this.state.insertLoading) ||
            (nextProps.apiResponse.actionType ===
                actionTypes.REPORT_PLUGIN_USAGE_FAILURE &&
                this.state.insertLoading)
        ) {
            setTimeout(() => {
                this.setState({
                    insertLoading: false,
                    isInserting: true
                });
            }, 3000);
        } else {
            this.setState({
                isInserting: false
            });
        }

        let currentIconId = this.props.icon
            ? this.props.icon.id
            : this.props.iconId;
        let nextIconId = nextProps.icon ? nextProps.icon.id : nextProps.iconId;

        if (currentIconId !== nextIconId) {
            if (nextProps.icon) {
                this.props.fetchSVGData(nextProps.icon.icon_url, nextIconId);
            }
            this.props.fetchViewMoreIcons(nextIconId, 24, 0);
        } else if (
            nextProps.icon &&
            !nextProps.icon.raw_svg &&
            !nextProps.icon.loadingRawSVG
        ) {
            this.props.fetchSVGData(nextProps.icon.icon_url, nextProps.icon.id);
        }
    }

    constructor(props) {
        super(props);

        const sizeKeys = ["24", "84", "150", "300", "600", "1000", "custom"],
            imgSizes = {};
        sizeKeys.forEach(size => {
            imgSizes[size] = { size: `${size}px` };

            if (size === "custom") {
                imgSizes[size] = { size: "" };
            }
        });
        this.state = {
            showSizeOptions: false,
            imgChoices: {
                sizes: imgSizes,
                keys: sizeKeys,
                selectedSize: !this.props.icon.selectedSize
                    ? "300px"
                    : this.props.icon.selectedSize
            },
            insertLoading: false,
            isInserting: false
        };
    }

    placeIcon() {
        let assetData;

        switch (this.props.host) {
            case "office":
                let color = this.props.icon.selectedColor.hex;

                // Force capitalization
                color = color.toUpperCase();

                if (color === "BLACK") {
                    color = "#000000";
                } else if (color === "WHITE") {
                    color = "#ffffff";
                }

                assetData = {
                    icon_id: this.props.icon.id,
                    color: color.replace("#", "")
                };

                this.setState({ insertLoading: true });
                break;
            case "adobe":
                assetData = this.props.icon.cleaned_svg;
                this.setState({ insertLoading: true });
                break;
            case "gsuite":
                this.setState({ insertLoading: true });
                break;
        }

        if (this.props.icon.freemium) {
            this.placeIconAction(assetData);
        } else {
            if (this.props.currentUser.has_premium_account) {
                this.placeIconAction(assetData);
            } else {
                hashHistory.push("signup");
            }
        }
    }

    placeIconAction(assetData) {
        let color = this.props.icon.selectedColor.hex,
            fileType = this.props.host === "office" ? "png" : "svg",
            size;

        // Force capitalization
        color = color.toUpperCase();

        if (color === "BLACK") {
            color = "#000000";
        } else if (color === "WHITE") {
            color = "#ffffff";
        }

        if (this.state.imgChoices.selectedSize === "custom") {
            size = parseInt(this.state.imgChoices.sizes["custom"].size);
            if (isNaN(size)) {
                size = "300";
            }
        } else {
            size = parseInt(
                this.state.imgChoices.sizes[
                    parseInt(this.state.imgChoices.selectedSize)
                ].size
            );
        }

        if (this.props.adobeAgent === "IDSN") {
            this.props.reportPluginUsage(
                this.props.icon.id,
                `${this.props.host}_plugin`,
                "pdf",
                color
            );
            return this.props.placePluginPDF(
                this.props.icon,
                color.replace("#", ""),
                size
            );
        } else {
            if (this.props.host === "adobe") {
                this.props.reportPluginUsage(
                    this.props.icon.id,
                    `${this.props.host}_plugin`,
                    "svg",
                    color
                );
                return this.props.placePluginSVG(
                    this.props.icon,
                    this.props.icon.selectedColor,
                    size
                );
            }
            if (this.props.host === "office") {
                this.props.reportPluginUsage(
                    this.props.icon.id,
                    `${this.props.host}_plugin`,
                    "png",
                    color
                );
                return this.props.placePluginPNG(
                    assetData,
                    size,
                    this.props.host
                );
            }
            if (this.props.host === "gsuite") {
                this.props.reportPluginUsage(
                    this.props.icon.id,
                    `${this.props.host}_plugin`,
                    "png",
                    color
                );
                return this.props.placePluginPNGGSuite(
                    this.props.icon,
                    color.replace("#", ""),
                    size
                );
            }
        }
    }

    showSizeOptions() {
        this.setState({
            showSizeOptions: true
        });
    }

    renderSizeOptions() {
        if (this.state.showSizeOptions) {
            let options = [];

            this.state.imgChoices.keys.forEach(size => {
                if (size !== "custom") {
                    options.push(
                        <li
                            key={this.state.imgChoices.sizes[size].size}
                            onClick={this.setSize.bind(
                                this,
                                this.state.imgChoices.sizes[size].size
                            )}
                            className={
                                this.state.imgChoices.selectedSize ===
                                this.state.imgChoices.sizes[size].size
                                    ? "selected"
                                    : ""
                            }
                        >
                            {this.state.imgChoices.sizes[size].size}
                        </li>
                    );
                }
            });

            return (
                <ul className="plugin-select-box-options">
                    {options}
                    <li
                        className={`no-hover-style ${
                            this.state.imgChoices.selectedSize === "custom"
                                ? "selected"
                                : ""
                        }`}
                    >
                        <form
                            name="customSize"
                            className="custom-size"
                            target="#here"
                            method="post"
                            onSubmit={this.setSize.bind(this, null)}
                        >
                            <input
                                type="number"
                                placeholder="Custom Size"
                                min="8"
                                max="1000"
                                onBlur={this.validateCustomSize.bind(this)}
                                onChange={this.setCustomSize.bind(this)}
                                style={{ width: "100%" }}
                                value={
                                    this.state.imgChoices.sizes["custom"].size
                                }
                            />
                            <input
                                type="submit"
                                style={{
                                    position: "absolute",
                                    left: "-9999px",
                                    width: "1px",
                                    height: "1px"
                                }}
                                tabIndex="-1"
                            />
                        </form>
                    </li>
                </ul>
            );
        } else {
            null;
        }
    }

    renderSelectedColor() {
        let selectedColor = this.props.icon.selectedColor.hex;
        if (!selectedColor) {
            // use state
            selectedColor = this.state.colorPalette.selectedColor.hex;
        }

        return (
            <span className="selected-color">
                <span
                    className="color-swatch"
                    style={{
                        backgroundColor: selectedColor
                    }}
                />
                {selectedColor}
            </span>
        );
    }

    renderColorOptions() {
        if (this.state.showColorOptions) {
            let colorKey = 0,
                options = [];

            this.props.icon.colorPalette.forEach(color => {
                colorKey = colorKey + 1;
                options.push(
                    <li
                        className={
                            this.props.icon.selectedColor.hex === color.hex
                                ? "selected"
                                : ""
                        }
                        key={`${colorKey}-${color.hex}`}
                        onClick={this.setColor.bind(this, color.hex)}
                    >
                        <span
                            className="color-swatch"
                            style={{ backgroundColor: color.hex }}
                        />
                        {color.hex}
                    </li>
                );
            });

            return (
                <ul className="plugin-select-box-options">
                    {options.reverse()}
                    <li
                        className={
                            this.props.icon.selectedColor.hex === "White"
                                ? "selected"
                                : ""
                        }
                        onClick={this.setColor.bind(this, "White")}
                    >
                        <span
                            className="color-swatch"
                            style={{ backgroundColor: "white" }}
                        />
                        {"White"}
                    </li>
                    <li
                        className={
                            !this.props.icon.selectedColor ||
                            this.props.icon.selectedColor.hex === "Black"
                                ? "selected"
                                : ""
                        }
                        onClick={this.setColor.bind(this, "Black")}
                    >
                        <span
                            className="color-swatch"
                            style={{ backgroundColor: "black" }}
                        />
                        {"Black"}
                    </li>
                    <li onClick={this.showColorChoose.bind(this)}>
                        Custom Color
                    </li>
                </ul>
            );
        }
    }

    renderColorChoose() {
        if (this.state.showColorChoose) {
            return (
                <ColorPicker
                    color={this.props.icon.selectedColor}
                    onChange={this.handleColorChange}
                />
            );
        }
    }

    handleColorChange = color => {

    };

    hideSizeOptions() {
        this.setState({
            showSizeOptions: false
        });
    }

    searchTag(slug, e) {
        e.preventDefault();

        this.props.setSearchTerm(slug);
        this.props.clearActiveIcon();
        hashHistory.push(`search/${slug}`);
    }

    render() {
        if (this.props.icon) {
            if (this.props.icon.raw_svg) {
                let detailButtonData = this.renderButtonData(),
                    country,
                    viewMoreIcons,
                    tags = [],
                    uploader,
                    sizeOptions = this.renderSizeOptions();

                if (this.props.icon.tags) {
                    this.props.icon.tags.forEach(tag => {
                        tags.push(
                            <li
                                className="hero-tag"
                                key={tag.slug + "." + tag.id}
                                style={{
                                    margin: "0 8px 0 0",
                                    whiteSpace: "nowrap",
                                    display: "inline-block"
                                }}
                            >
                                <a
                                    onClick={this.searchTag.bind(
                                        this,
                                        tag.slug
                                    )}
                                    href="#"
                                    title={
                                        "View " +
                                        tag.slug.split("-").join(" ") +
                                        " icons"
                                    }
                                    style={{ textDecoration: "underline" }}
                                >
                                    {tag.slug.split("-").join(" ")}
                                </a>
                            </li>
                        );
                    });
                }

                if (this.props.icon.uploader) {
                    if (this.props.icon.uploader.location) {
                        country = this.props.icon.uploader.location.split(", ");
                        country = country[country.length - 1];
                        country = (
                            <span className="uploader-location">
                                , {country}
                            </span>
                        );
                    }
                    if (this.props.icon.uploader.name) {
                        uploader = (
                            <span className="designer weight-light">
                                By <span>{this.props.icon.uploader.name}</span>
                                {country}
                            </span>
                        );
                    }
                }

                let selectedSize;
                if (this.state.imgChoices.selectedSize !== "custom") {
                    selectedSize = this.state.imgChoices.sizes[
                        parseInt(this.state.imgChoices.selectedSize)
                    ].size;
                } else {
                    selectedSize = this.state.imgChoices.sizes[
                        this.state.imgChoices.selectedSize
                    ].size;
                    if (selectedSize === "") {
                        selectedSize = "300px";
                    } else {
                        selectedSize = `${selectedSize.replace("px", "")}px`;
                    }
                }

                if (this.props.viewMore.icons) {
                    let viewMoreTitle = <span>&nbsp;</span>;
                    if (!this.props.viewMore.collection) {
                        // Related icons are from user
                        viewMoreTitle = `More from this creator`;
                    } else {
                        // Related icons are in collection
                        let collectionName =
                            this.props.viewMore.collection.name
                                .toLowerCase()
                                .indexOf("collection") >= 1
                                ? this.props.viewMore.collection.name
                                : this.props.viewMore.collection.name +
                                  " Collection";

                        viewMoreTitle = (
                            <span>{`More from ${collectionName}`}</span>
                        );
                    }

                    viewMoreIcons = (
                        <div
                            className="view-more-plugin"
                            style={{ margin: "20px 0 0" }}
                        >
                            <style>
                                {`
                                    .view-more-plugin .nounproject-iconlist {
                                        margin: 0;
                                    }
                                `}
                            </style>
                            {viewMoreTitle}
                            <IconList
                                maxIcons={24}
                                iconSize={"84"}
                                icons={this.props.viewMore.icons}
                                dragAndDrop={false}
                                pluginViewMore={true}
                            />
                        </div>
                    );
                }

                return (
                    <div
                        style={{
                            background: "#FFFFFF",
                            padding: "100px 16px 100px",
                            minHeight: "100%"
                        }}
                    >
                        <style>{`
                            .plugin-select-box{
                                position: relative;
                                width: 100%;
                                display: flex;
                                justify-content: flex-end;
                                align-items: baseline;
                                cursor: pointer;
                            }
                            .current-selection{
                                padding: 3px 8px;
                                margin-bottom: 7px;
                                width: 100%;
                                background: #FAFAFA;
                                border: solid 1px #F2F2F2;
                                display: flex;
                                position: relative;
                                justify-content: space-between;
                            }
                            .current-selection .ui_down-drop-arrow{
                                font-size: 12px;
                                color: #BABABA;
                            }
                            .plugin-select-box-options{
                                background: #F2F2F2;
                                border-radius: 1px;
                                border: solid 1px #D8D8D8;
                                bottom: 0;
                                left: 0;
                                position: absolute;
                                width: 100%;
                                z-index: 99;
                            }
                            .current-selection.show-options .plugin-select-box-options{
                                visibility: visible;
                                opacity: 1;
                                max-height: 400px;
                            }
                            .plugin-select-box-options li{
                                cursor: pointer;
                                padding: 4px 8px;
                            }
                            .plugin-select-box-options li.no-hover-style{
                                border-top: solid 1px #D8D8D8;
                            }
                            .plugin-select-box-options li:not(.no-hover-style):hover,
                            .plugin-select-box-options li.selected
                            {
                                background: #6D6D6D;
                                color: #FFFFFF;
                            }
                            .plugin-select-box-options li input{
                                padding: 4px;
                                margin: 4px 0;
                                max-width: 100%;
                            }
                            .color-swatch{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                                background: black;
                                display: inline-block;
                            }
                            .selected-color{
                                padding-left: 24px;
                            }
                            .selected-color .color-swatch{
                                width: 23px;
                                height: 23px;
                                position: absolute;
                                top: 0;
                                left: 0;
                            }

                            #custom-color-picker{
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                z-index: 9;
                                background: #FFFFFF;
                                border: solid 3px #F2F2F2;
                                display: flex;
                                align-items: flex-start;
                                justify-content: flex-start;
                                width: 306px;
                            }
                            .color-picker-pointer-hue{
                                width: 24px;
                                height: 4px;
                                border: solid 1px #000;
                                box-shadow: 0 0 0 1px #fff;
                                transform: translate(-2px, -2px);
                                transition: 0.3s ease-out;
                                transition-property: height, width, transform;
                                z-index: 8;
                                position: relative;
                            }
                            #hue:hover .color-picker-pointer-hue{
                                width: 36px;
                                height: 24px;
                                transform: translate(-8px, -12px);
                                z-index: 10;
                            }
                            .custom-color-inputs{
                                width: 100%;
                                max-width: 80px;
                            }
                            .color-picker-pointer-circle{
                                width: 12px;
                                height: 12px;
                                border-radius: 50%;
                                border: solid 1px #000;
                                box-shadow: 0 0 0 1px #fff;
                                transform: translate(-6px, -6px);
                                transition: 0.3s ease-out;
                                transition-property: height, width, transform;
                                z-index: 9;
                                position: relative;
                            }
                            #Saturation:hover .color-picker-pointer-circle{
                                width: 48px;
                                height: 48px;
                                transform: translate(-24px, -24px);
                            }
                            #hue,
                            #Saturation{
                                flex-shrink: 0;
                            }
                            #custom-color-picker label{
                                position: absolute;
                                padding: 2px 4px;
                                color: #6D6D6D;
                            }
                            #custom-color-picker input{
                                width: 100%;
                                min-width: 90px;
                                padding: 2px 4px 2px 18px;
                                background: #ffffff;
                                border: solid 1px #F2F2F2;
                            }
                            .color-box-group{
                                padding: 4px;
                            }
                            .detail-locked-indicator{
                                position: absolute;
                                top: 8px;
                                right: 8px;
                                padding: 4px;
                                width: 22px;
                                height: 22px;
                                background: #3EA9F5;
                                border-radius: 4px;
                                z-index: 3;
                            }
                            .custom-size input[type=number]::-webkit-inner-spin-button,
                            .custom-size input[type=number]::-webkit-outer-spin-button {
                              -webkit-appearance: none;
                              margin: 0;
                            }
                            .plugin-select-size{
                                margin-right: 16px;
                            }
                            .icon-editing{
                                align-items: flex-start
                                }
                            .the-icon-container{
                                margin: 0 auto 8px;
                            }
                            @media only screen and (max-width: 500px) {
                                .icon-editing{
                                    flex-direction: column-reverse;
                                    align-items: flex-end;
                                }
                                .hero-color-picker{
                                    margin-bottom: 8px;
                                }
                                .plugin-select-size{
                                    margin: 0;
                                }
                                #custom-color-picker{
                                    width: auto;
                                    flex-direction: column;
                                }
                                .custom-color-inputs{
                                    max-width: 350px;
                                }
                            }
                            @media only screen and (max-width: 250px) {
                                .the-icon-container{
                                    min-height: 250px;
                                }
                                #custom-color-picker{
                                    max-width: 150px;
                                }
                                #Saturation{
                                    width: 120px !important;
                                    height: 120px !important;
                                }
                                #hue{
                                    height: 120px !important;
                                }
                            }
                            @media only screen and (max-width: 200px) {
                                .the-icon-container{
                                    min-height: 200px;
                                }
                            }
                            @media only screen and (max-width: 150px) {
                                .the-icon-container{
                                    min-height: 150px;
                                }
                            }

                        `}</style>
                        <div
                            className={`plugin the-icon-container ${
                                this.props.icon.customColorSelected
                                    ? "updated"
                                    : ""
                            }`}
                        >
                            <div
                                className="icon-box display-flex"
                                style={{ alignItems: "center" }}
                            >
                                {detailButtonData.status}
                                <NounProjectPreviewIcon
                                    cleanedSvgCallback={this.saveCleanedSVG.bind(
                                        this
                                    )}
                                    svg={this.props.icon.raw_svg}
                                    icon={this.props.icon}
                                    imgSize={"300px"}
                                    isEditable={true}
                                    isInserting={this.state.isInserting}
                                    selectedColor={
                                        this.props.icon.selectedColor.hex
                                    }
                                />
                            </div>
                        </div>
                        <button
                            className={detailButtonData.class.join(" ")}
                            onClick={this.placeIcon.bind(this)}
                        >
                            <span>{detailButtonData.text}</span>
                        </button>

                        <div className="meta-data">
                            {this.renderIconEditing(selectedSize, sizeOptions)}

                            <div
                                className="display-flex"
                                style={{ lineHeight: "1.5" }}
                            >
                                <div className="hero-title">
                                    <h1
                                        className="main-term"
                                        style={{
                                            fontSize: "14px",
                                            textTransform: "capitalize"
                                        }}
                                    >
                                        {this.props.icon.term}
                                    </h1>
                                    {uploader}
                                </div>
                                <div className="hero-actions">
                                    <a
                                        target="_blank"
                                        href={this.props.icon.permalink}
                                        title="View on the web"
                                        onClick={window.handleLink.bind(this)}
                                    >
                                        <Icon
                                            iconId="share_arrow.svg"
                                            className="icon-14"
                                        />
                                    </a>
                                </div>
                            </div>
                            {viewMoreIcons}
                            <div className="hero-tags">
                                <ul
                                    className="hero-tags-list"
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        margin: "10px 12px 0 0"
                                    }}
                                />
                                {tags}
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return null;
    }

    renderButtonData() {
        let buttonData = {
            class: ["button", "full-width", "button-process"],
            text: "Unlock to Insert",
            status: (
                <Icon
                    iconId="lock.svg"
                    className="detail-locked-indicator icon-14"
                    color="#FFFFFF"
                    title="Unlock with NounPro"
                />
            )
        };
        if (
            this.props.currentUser.has_premium_account ||
            this.props.icon.freemium
        ) {
            buttonData.class.push("ui_download");
            buttonData.text = "Insert Icon";
            buttonData.status = null;

            if (this.state.insertLoading) {
                buttonData.class.push("processing blue");
            } else {
                buttonData.class.push("black");
            }
        } else {
            buttonData.class.push("blue", "ui_unlock");
        }

        return buttonData;
    }

    renderIconEditing(selectedSize, sizeOptions) {
        let iconEditing, hideSizeOptionsDom;

        if (this.state.showSizeOptions) {
            hideSizeOptionsDom = (
                <div
                    className="hideSizeOptionsDom"
                    onClick={this.hideSizeOptions.bind(this)}
                    style={{
                        position: "fixed",
                        width: "100%",
                        height: "100%",
                        display: "block",
                        zIndex: "8",
                        top: "0",
                        left: "0"
                    }}
                />
            );
        }

        iconEditing = (
            <div className="icon-editing display-flex">
                <div className="plugin-select-box plugin-select-size">
                    <div className="current-selection">
                        <span
                            className="display-flex"
                            style={{ width: "100%" }}
                            onClick={this.showSizeOptions.bind(this)}
                        >
                            {selectedSize}
                            <span className="ui_down-drop-arrow" />
                        </span>
                        {sizeOptions}
                        {hideSizeOptionsDom}
                    </div>
                </div>
                <ColorSelection icon={this.props.icon} />
            </div>
        );

        return iconEditing;
    }

    saveCleanedSVG(cleanedSVG) {
        //if (!this.props.icon.cleaned_svg) {
        if (this.props.icon.cleaned_svg !== cleanedSVG) {
            this.props.saveCleanedSVG(cleanedSVG);
        }
    }

    setCustomSize(e) {
        let imgChoices = Object.assign([], this.state.imgChoices);
        imgChoices.selectedSize = "custom";
        imgChoices.sizes["custom"].size = e.target.value;

        this.setState({
            imgChoices: imgChoices
        });
    }

    setSize(imgSize, e) {
        e.preventDefault();
        let size,
            imgChoices = Object.assign([], this.state.imgChoices);

        if (!imgSize) {
            imgChoices.selectedSize = "custom";
        } else {
            imgChoices.selectedSize = imgSize;
            size = imgSize;
        }

        this.setState({
            imgChoices: imgChoices
        });

        this.hideSizeOptions();

        this.props.setSize(imgChoices);
    }

    validateCustomSize(e) {
        let imgChoices = Object.assign([], this.state.imgChoices);
        imgChoices.selectedSize = "custom";
        imgChoices.sizes["custom"].size = e.target.value;

        if (parseInt(e.target.value) > 8 && parseInt(e.target.value) < 1201) {
            this.setState({
                imgChoices: imgChoices
            });
        } else {
            if (parseInt(e.target.value) < 8) {
                imgChoices.sizes["custom"].size = "8";
                this.setState({
                    imgChoices: imgChoices
                });
            }
            if (parseInt(e.target.value) > 1000) {
                imgChoices.sizes["custom"].size = "1000";
                this.setState({
                    imgChoices: imgChoices
                });
            }
        }
    }
}

function mapStateToProps(state, ownProps) {
    let apiResponse = state.apiResponse,
        currentUser = state.user,
        icon,
        host,
        viewMore = {},
        adobeAgent = state.plugin.adobeAgent;

    host = state.plugin.host;

    let { iconId } = ownProps;

    icon = state.icons[iconId];
    if (!icon && state.icons.viewMore) {
        icon = state.icons.viewMore[iconId];
    }

    if (icon) {
        if (state.icons.colorPalette) {
            icon.colorPalette = state.icons.colorPalette;
        }
        if (state.icons.selectedColor) {
            icon.selectedColor = state.icons.selectedColor;
            if (
                state.icons.selectedColor.hex !== "black" &&
                state.icons.selectedColor.hex !== "#000000"
            ) {
                icon.customColorSelected = true;
            } else {
                icon.customColorSelected = false;
            }
        }

        icon.selectedSize = state.icons.imgChoices.selectedSize;

        if (state.icons.active_icon && state.icons.active_icon.id == iconId) {
            icon.raw_svg = state.icons.active_icon.raw_svg;
            icon.loadingRawSVG = state.icons.active_icon.loadingRawSVG;
            icon.cleaned_svg = state.icons.active_icon.cleaned_svg;
        }
    }

    if (state.icons.viewMore) {
        viewMore.icons = state.icons.viewMore.keys.map(
            viewMoreKey => state.icons.viewMore[viewMoreKey]
        );
        viewMore.collection = state.icons.viewMore.collection;
        viewMore.totalRelatedCount = state.icons.total_related_count;
    }

    return { apiResponse, viewMore, currentUser, icon, host, adobeAgent };
}

module.exports = connect(
    mapStateToProps,
    {
        placePluginPDF: actions.placePluginPDF,
        placePluginSVG: actions.placePluginSVG,
        clearActiveIcon: actions.clearActiveIcon,
        fetchIcon: actions.fetchIcon,
        fetchSVGData: actions.fetchSVGData,
        fetchViewMoreIcons: actions.fetchViewMoreIcons,
        placePluginPNG: actions.placePluginPNG,
        placePluginPNGGSuite: actions.placePluginPNGGSuite,
        reportPluginUsage: actions.reportPluginUsage,
        setColor: actions.setColor,
        saveCleanedSVG: actions.saveCleanedSVG,
        setSize: actions.setSize,
        setActiveIcon: actions.setActiveIcon,
        setSearchTerm: actions.setSearchTerm
    }
)(NounProjectPluginIconDetail);
